import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setScheduleToggleStatus } from "../../../redux/slices/statistics/statisticSlice";

function ToggleDetails() {
  const dispatch = useDispatch();
  const Status = useSelector((state) => state.statistics.ScheduleStatsToggleStatus);

  return (
    <div className="flex items-center justify-center w-full mt-8 mb-6">
      <label htmlFor="toggleB" className="flex items-center ">
        <div className="relative">
          <input id="toggleB" className="sr-only" />
            <div className="block bg-cyan-100 w-60 h-10 rounded-full">
              <div className="flex flex-row justify-evenly pt-3">
                <p
                  onClick={() => dispatch(setScheduleToggleStatus("General"))}
                  className="pl-4 text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
                >
                 General
                </p>
                <p
                  onClick={() => dispatch(setScheduleToggleStatus("Group/User"))}
                  className="pl-4 text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
                >
                 Group/User
                </p>
              
              </div>
            </div>
              {Status === "General" ? (
                <div className="absolute left-8 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                  General
                </div>
              ) : null}
              {Status === "Group/User" ? (
                <div className="absolute left-32 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                 Group/User
                </div>
              ) : null}
           
        </div>
      </label>
    </div>
  );
}

export default ToggleDetails;
